import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const SubscriptionsPage = lazy(() => import('@/pages/subscriptions'));

export const Route = createFileRoute('/subscriptions')({
  component: function SubscriptionsRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <SubscriptionsPage />
      </Suspense>
    );
  },
});
